// eslint-disable-next-line import/prefer-default-export
export function filterAllStationsString(str) {
  if (typeof str !== 'string') {
    return str;
  }
  return str.replace(/ - All Stations/g, '');
}
